import React from 'react';
import {Navigate, useLocation, useParams} from 'react-router'
import {useSelector} from 'react-redux';
import {isCruiseStartDateDenied} from "../../utils/dateTimeUtils";
import {getExternalUrl} from "../../utils/configUtils";
import { useLingui } from '@lingui/react/macro';

function AuthRoute({component: Component, ...rest}) {
    const isAuthenticated = useSelector(state => state.authentication.isAuthenticated);
    const cruiseStartDate = useSelector(state => state.cruises && state.cruises.cruiseStartDate ? state.cruises.cruiseStartDate : null);
    const isAgency = useSelector(state => state.agency.isAuthenticated);
    const {t} = useLingui();

    const location = useLocation();
    const params = useParams();

    const externalUrl = getExternalUrl();

    if (!isAuthenticated) {
        if (externalUrl) {
            window.location.href = externalUrl;
            return null;
        }
        return (
            <Navigate
                to="/login"
                state={{ forward_to: window.location.pathname }}
                replace
            />
        );
    }

    if (isCruiseStartDateDenied(cruiseStartDate, isAgency)) {
        return <Navigate to={t({id: "/logoutUser"})} replace />;
    }

    return <Component {...rest} location={location} params={params} />;
}

export default AuthRoute;